import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { LEGAL_PAGES } from "@/data/legal";
import { ArrowLeft } from "lucide-react";

export default function Legal() {
  const { slug } = useParams();
  const page = Object.values(LEGAL_PAGES).find((p) => p.slug === slug);
  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#FDFBF9] text-[#2C2420]">
      <header className="border-b border-[#EADBD1] bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-baseline gap-2" data-testid="legal-home-link">
            <span className="font-serif text-xl md:text-2xl tracking-tight">French Curl</span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#C58C85]">Vibes</span>
          </Link>
          <Link to="/" className="text-sm text-[#6B5D54] hover:text-[#2C2420] inline-flex items-center gap-1.5">
            <ArrowLeft className="h-4 w-4" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-20">
        <p className="text-xs uppercase tracking-[0.28em] font-medium text-[#C58C85]">Information légale</p>
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-4 text-[#2C2420]" data-testid="legal-title">
          {page.title}
        </h1>
        {page.intro && <p className="mt-4 text-[#6B5D54] text-base md:text-lg">{page.intro}</p>}

        <div className="mt-12 space-y-10">
          {page.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-serif text-2xl md:text-3xl text-[#2C2420] tracking-tight">{s.heading}</h2>
              {s.body && (
                <div className="mt-4 space-y-3 text-[#2C2420]/85 text-[15px] leading-relaxed">
                  {s.body.map((p, idx) => <p key={idx}>{p}</p>)}
                </div>
              )}
              {s.list && (
                <ul className="mt-4 space-y-2">
                  {s.list.map((it, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-[#2C2420]/85 text-[15px]">
                      <span className="mt-2.5 h-1.5 w-1.5 rounded-full bg-[#C58C85] flex-shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.footer && <p className="mt-4 text-sm text-[#6B5D54] italic">{s.footer}</p>}
              {s.qa && (
                <div className="mt-5 space-y-5">
                  {s.qa.map((qa, idx) => (
                    <div key={idx} className="rounded-2xl bg-white border border-[#EADBD1] p-5">
                      <p className="font-medium text-[#2C2420]">{qa.q}</p>
                      <p className="text-[15px] text-[#6B5D54] mt-2">{qa.a}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[#EADBD1]">
          <Link to="/" className="text-sm text-[#C58C85] hover:underline">
            ← Retour à l&apos;accueil
          </Link>
        </div>
      </main>
    </div>
  );
}
